// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"4d342d77","1054":"4d342d77","6751":"100065f3"}[chunkId] + ".chunk.css";
};